import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
    ADD_NEW_CONTAINER,
    DELETE_CONTAINER,
    CONTAINER_FORM_TOOGLE_LOADING,
    SET_CONTAINER_LIST,
    SHOW_NOTIFICATION,
    UPDATE_CONTAINER,
} from "../constants";
import { formatContainers } from "./settingsActionsUtils";

/* CONTAINER LIST */
export const fetchContainers = () => {
    return async (dispatch) => {
        const response = await axios
            .get(API.containers.list)
            .then((response) => {
                const containers = formatContainers(response.data);
                dispatch({
                    type: SET_CONTAINER_LIST,
                    payload: keyBy(containers, "_id"),
                });
                return response.status;
            })
            .catch((err) => err);
        return response;
    };
};

// CONTAINERS
export const createContainer = (newContainer) => {
    return async (dispatch) => {
        dispatch({ type: CONTAINER_FORM_TOOGLE_LOADING });
        const response = await axios
            .post(API.containers.create, newContainer)
            .then((response) => {
                const container = formatContainers(response.data);
                dispatch({ type: ADD_NEW_CONTAINER, payload: container });
                dispatch({ type: CONTAINER_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "success",
                        message: "Envase creado con éxito.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: CONTAINER_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const updateContainer = (updatedContainer) => {
    return async (dispatch) => {
        dispatch({ type: CONTAINER_FORM_TOOGLE_LOADING });
        const response = await axios
            .put(`${API.containers.edit}${updatedContainer && updatedContainer._id}`, updatedContainer)
            .then((response) => {
                const container = formatContainers(response.data);
                dispatch({ type: UPDATE_CONTAINER, payload: container });
                dispatch({ type: CONTAINER_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Envase actualizado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: CONTAINER_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const deleteContainers = (Ids) => {
    return async (dispatch) => {
        dispatch({ type: CONTAINER_FORM_TOOGLE_LOADING });
        const response = await axios
            .delete(`${API.containers.delete}`, { data: Ids })
            .then((response) => {
                dispatch({ type: DELETE_CONTAINER, payload: Ids });
                dispatch({ type: CONTAINER_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Envase eliminado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: CONTAINER_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};
